import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CustomMode, CustomProduct } from '@app/app.constants';
import { ContextService } from '@app/core/context.service';
import { WindowToken } from '@app/core/window.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit, OnDestroy {
  CustomMode = CustomMode;
  mode?: CustomMode;
  isLoading = true;

  private sub: Subscription;

  constructor(
    private contextService: ContextService,
    @Inject(WindowToken) private window: Window
  ) { }

  ngOnInit() {
    this.sub = this.contextService.getLoadingObservable()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe();

    const url = this.window.location.href.toLocaleLowerCase();
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      this.contextService.marketplaceAccountId = httpParams.get('marketplace_account_id');
      this.contextService.product = httpParams.get('product') as CustomProduct;
    }
    this.mode = this.contextService.getCustomMode();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}

